import ObjectModelBuilderModel from "~/models/tracked/objectModelBuilderModel";
import {ObjectModelPermissionType} from "~/enums/objectModelPermissionType";
import {ObjectModelPermissionCapabilityType} from "~/enums/objectModelPermissionCapabilityType";
import ObjectModel from "~/models/objectModel";
import IRepo from "~/interfaces/repo";
import Repo from "~/state/modules/repo";
import {IObjectModelPermissionConstructorOptions} from "~/interfaces/objectModelInterfaces";
import Guid from "~/helpers/guid";
import {IPermission} from '~/interfaces/permissionInterfaces'

export default class ObjectModelPermission extends ObjectModelBuilderModel implements IPermission {
  permittee_client_id: string;
  permittable_client_id: string;
  permission_type: ObjectModelPermissionType;
  capability_type: ObjectModelPermissionCapabilityType;

  static repo: IRepo<ObjectModelPermission> = new Repo<ObjectModelPermission>('objectModelPermissions', ObjectModelPermission);

  constructor(parent: ObjectModel, options: IObjectModelPermissionConstructorOptions) {
    super();
    const json = options.json || {};
    this.defineProperty('client_id', json['client_id'] || Guid.create());
    this.defineProperty('permittee_client_id', json['permittee_client_id'] || null);
    this.defineProperty('permittable_client_id', json['permittable_client_id'] || null);
    this.defineProperty('permission_type', json['permission_type'] || null);
    this.defineProperty('capability_type', json['capability_type'] || null);
  }

  get rootName(): string {
    return 'permissions';
  }

  initialize<T extends ObjectModelPermission>(rootModel: ObjectModel, parent: ObjectModel = rootModel, type?: null, json: object = {}) {
    this.attachToParent(parent);
    return this;
  }
}